const DEFAULT_LAT = 48.858253;
const DEFAULT_LNG = 2.294343;
const DEFAULT_RADIUS = 50000;

export const INCLUDED_PRIMARY_TYPES = [
  'premise',
  'subpremise',
  'street_address',
] as const;

export const defaultSearchOptions = () => ({
  includedPrimaryTypes: [...INCLUDED_PRIMARY_TYPES],
  locationBias: {
    center: { lat: DEFAULT_LAT, lng: DEFAULT_LNG },
    radius: DEFAULT_RADIUS,
  },
});
